import React from 'react';
import ajax from '../../../ajax';
import functions from '../../../functions';
import DashCard from '../../Common/DashCard';


class MonthlyDepositsCard extends React.Component {
  
  state={
    userId:functions.sessionGuard(),
    value:'...'
  }
  async componentDidMount()
  {
    await this.requestRecord();
    this.timer = setTimeout(this.func=async()=> {
      await this.requestRecord();
      this.timer = setTimeout(this.func, 2000); // (*)
    }, 2000);
  }

  componentWillUnmount()
  {
    clearTimeout(this.timer)
  }

  requestRecord=async()=>{
    const server_response=await ajax.totalOngoingSecurityDepositRequests();
    if(server_response.status==="OK")
    {
      this.setState({
        value:server_response.details.amount_c
      })
    }
  }

  render(){
    
      return (
        <DashCard 
            title="Monthly Deposits"
            value={this.state.value}
            caption="This month's deposits"
            subValue="UGX"
            />

      );
    
 
  }
}

export default MonthlyDepositsCard;